import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';
import FurtherAssistanceContact from '../FurtherAssistanceContact';
import StepNavigation from '../StepNavigation/StepNavigation';
import TermsAndConditions from '../templates/ScheduleLayout/TermsAndConditions';
import { useAppointmentInformationStore } from '@src/store';
export interface IWizardFooterProps {
  baseUrl: string;
}
const WizardFooter: React.FC<IWizardFooterProps> = ({
  baseUrl
}) => {
  const {
    activeStep,
    isLastStep
  } = useWizard();
  const {
    t
  } = useTranslation('index');
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {
    noChosenAppointmentError
  } = useAppointmentInformationStore();
  return <>
			{!isLastStep && <Stack py={2.5} alignItems="center" justifyContent="center" sx={{
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px -1px 4px',
      position: 'static',
      bottom: 0,
      zIndex: 20,
      backgroundColor: 'backgrounds.white'
    }}>
					{noChosenAppointmentError && <Box role="alert">
							<Typography variant="bodyMediumBook" color="error.dark">
								{t('chooseAnotherTime')}
							</Typography>
						</Box>}
					{activeStep === 2 && <TermsAndConditions baseUrl={baseUrl} />}

					<Stack direction="row" spacing={1.5} alignItems="center">
						{!isLastStep && <StepNavigation />}
					</Stack>
				</Stack>}
			{isSmallScreen && <Box my={2.5} sx={{
      textAlign: 'center'
    }}>
					<FurtherAssistanceContact />
				</Box>}
		</>;
};
export default WizardFooter;